<template>
  <table class="table is-fullwidth is-striped">
    <thead>
      <tr>
        <th>Наименование документа</th>
        <th width="150px">Номер документа</th>
        <th width="150px">Дата документа</th>
        <th width="200px">Регистрационный номер в ГИСОГД</th>
        <th width="150px">Дата регистрации в ГИСОГД</th>
        <th width="80px" v-if="hasFile"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="doc in docs" :key="doc.key">
        <td>
          <router-link
            :to="{
              name: 'gisogdDoc',
              params: {
                projectSchema: projectSchema,
                gisogdSection: doc.gisogdSectionId,
                docId: doc.key,
              },
            }"
            class="doc-title"
          >
            {{ doc.name }}
          </router-link>
        </td>
        <td>{{ doc.docNum }}</td>
        <td>{{ doc.dateDoc | tryToLocaleDateTime }}</td>
        <td>{{ doc.numReg }}</td>
        <td>{{ doc.dateReg | tryToLocaleDateTime }}</td>
        <td class="file-cell" v-if="hasFile">
          <img src="../../assets/svg/file-download.svg" />
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: {
    projectSchema: {
      required: true,
      type: String,
    },
    docs: {
      type: Array,
      required: true,
    },
    hasFile: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss">
@import "../../assets/sass/main.scss";

.file-cell {
  border-left: solid 1px $white-ter !important;
  vertical-align: middle !important;
  text-align: center !important;
}
td .doc-title {
  cursor: pointer;
  display: inline-block;
}
</style>